export const KIND = {
  TREE: 'tree',
  INFO: 'info'
}

export const THEME = {
  DARK: 'dark',
  LIGHT: 'light'
}

export const TYPE = {
  TNVED: 'tnved',
  GNG: 'gng',
  ETSNG: 'etsng'
}

export const CLOSE_TYPE = {
  CLOSE: 'close',
  BACK: 'back'
}



// WEBPACK FOOTER //
// ./src/-enums.js